module.exports = __webpack_public_path__ + "img/icon-fb.8b67fa26.svg";